module.exports = __webpack_public_path__ + "static/media/Mobile.ca1e1199.svg";